import React, { forwardRef } from 'react';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import Tooltip from '@/components/_common/Tooltip';

export interface ConditionalTooltipProps extends TooltipProps {
  show: boolean;
  title: React.ReactNode;
  className?: string;
  isNewTooltip?: boolean;
}

const ConditionalTooltip = ({ show = false, children, title, className, isNewTooltip, ...props }: ConditionalTooltipProps, ref: any) => {
  if (!show) return children;

  const TooltipComponent = isNewTooltip ? Tooltip : MuiTooltip;

  return (
    <TooltipComponent title={title} aria-label="tooltip" className={className} {...props} ref={ref}>
      {children}
    </TooltipComponent>
  );
};
export default forwardRef(ConditionalTooltip);
